module.exports = __webpack_public_path__ + "static/media/unknown.a6dba436.svg";